import LeadAssignmentModal from './LeadAssignmentModal';

export default LeadAssignmentModal;
